export const streamers = [
  {
    id: "seo-yuna",
    name: "徐允儿",
    nameEn: "Seo Yuna",
    type: "新闻主播",
    region: "首尔",
    debutYear: 2016,
    program: "MBC 晚间新闻",
    position: "首席新闻主播",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20elegant%20Korean%20female%20news%20anchor%20in%20navy%20blazer%2C%20soft%20neutral%20beige%20background%2C%20warm%20editorial%20lighting%2C%20high%20detail%20fashion%20photography&width=600&height=800&seq=streamer-01&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20broadcast%20studio%20scene%20with%20Korean%20female%20anchor%20hosting%20live%20evening%20news%2C%20warm%20spotlights%2C%20modern%20tv%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-01-cover&orientation=landscape",
    bio: "韩国三大电视台之一的当家新闻主播，以沉稳大气的主持风格著称。曾主持多场大型现场直播与选举特别节目，被评为年度最具影响力主播之一。",
    followers: "216万",
    birthday: "1991-04-18",
    tags: ["知性", "晚间新闻", "资深"],
    heat: 98,
    updated: "2026-10-15",
  },
  {
    id: "im-sera",
    name: "林世拉",
    nameEn: "Im Sera",
    type: "娱乐主播",
    region: "首尔",
    debutYear: 2019,
    program: "首尔娱乐快报",
    position: "娱乐资讯主持",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20cheerful%20Korean%20female%20entertainment%20host%20in%20coral%20silk%20blouse%2C%20soft%20neutral%20cream%20background%2C%20bright%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-02&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=glamorous%20Korean%20entertainment%20show%20stage%20with%20female%20host%20and%20colorful%20lights%2C%20warm%20spotlights%2C%20modern%20studio%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-02-cover&orientation=landscape",
    bio: "新生代娱乐资讯主播代表，擅长明星采访与红毯直播。凭借亲和的台风与敏锐的娱乐嗅觉迅速走红，社交媒体话题度极高。",
    followers: "342万",
    birthday: "1996-09-02",
    tags: ["活力", "红毯", "人气"],
    heat: 96,
    updated: "2026-10-15",
  },
  {
    id: "jung-daeun",
    name: "郑多恩",
    nameEn: "Jung Daeun",
    type: "综艺主播",
    region: "釜山",
    debutYear: 2018,
    program: "周末综艺秀",
    position: "综艺节目主持",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20lively%20Korean%20female%20variety%20show%20host%20in%20yellow%20knit%20top%2C%20soft%20neutral%20background%2C%20warm%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-03&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=fun%20Korean%20weekend%20variety%20show%20stage%20with%20female%20host%20laughing%2C%20warm%20studio%20lights%2C%20colorful%20modern%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-03-cover&orientation=landscape",
    bio: "从釜山地方台一路走来的综艺红人，以极具感染力的笑声和反应速度闻名。常年活跃于周末黄金档综艺，被誉为气氛制造机。",
    followers: "187万",
    birthday: "1994-01-27",
    tags: ["幽默", "综艺", "气氛担当"],
    heat: 91,
    updated: "2026-10-14",
  },
  {
    id: "kang-jisu",
    name: "姜智秀",
    nameEn: "Kang Jisu",
    type: "新闻主播",
    region: "仁川",
    debutYear: 2015,
    program: "KBS 清晨新闻",
    position: "早间新闻主播",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20calm%20Korean%20female%20morning%20news%20anchor%20in%20white%20turtleneck%2C%20soft%20neutral%20beige%20background%2C%20clean%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-04&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=bright%20morning%20news%20studio%20with%20Korean%20female%20anchor%20at%20desk%2C%20soft%20window%20light%2C%20minimal%20modern%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-04-cover&orientation=landscape",
    bio: "清晨新闻的标志性面孔，十年如一日为观众带来清晨第一手资讯。声音温暖清晰，是许多家庭早餐时光的固定陪伴。",
    followers: "154万",
    birthday: "1989-11-09",
    tags: ["温暖", "早间", "十年"],
    heat: 88,
    updated: "2026-10-13",
  },
  {
    id: "han-sia",
    name: "韩诗雅",
    nameEn: "Han Si-a",
    type: "娱乐主播",
    region: "首尔",
    debutYear: 2020,
    program: "音乐银行",
    position: "音乐节目主持",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20trendy%20Korean%20female%20music%20show%20host%20in%20pastel%20pink%20jacket%2C%20soft%20neutral%20background%2C%20bright%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-05&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20Korean%20music%20chart%20show%20stage%20with%20female%20host%20and%20glowing%20lights%2C%20warm%20spotlights%2C%20modern%20stage%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-05-cover&orientation=landscape",
    bio: "音乐节目人气主持，凭借青春甜美的形象与稳健的直播功力圈粉无数。每周与顶流偶像同台，被粉丝称为舞台上的发光体。",
    followers: "298万",
    birthday: "1997-06-15",
    tags: ["甜美", "音乐", "偶像同台"],
    heat: 94,
    updated: "2026-10-15",
  },
  {
    id: "park-nayeon",
    name: "朴娜妍",
    nameEn: "Park Nayeon",
    type: "综艺主播",
    region: "大邱",
    debutYear: 2017,
    program: "搞笑演唱会",
    position: "喜剧综艺主持",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20expressive%20Korean%20female%20comedy%20host%20in%20green%20blouse%2C%20soft%20neutral%20background%2C%20warm%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-06&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=lively%20Korean%20comedy%20show%20stage%20with%20female%20host%20performing%2C%20warm%20colorful%20lights%2C%20theater%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-06-cover&orientation=landscape",
    bio: "从大邱小剧场走向全国荧屏的喜剧女主播，模仿与即兴能力一流。她主持的段落常年在网络平台拥有超高播放量。",
    followers: "132万",
    birthday: "1993-03-30",
    tags: ["喜剧", "模仿", "爆笑"],
    heat: 85,
    updated: "2026-10-12",
  },
  {
    id: "choi-subin",
    name: "崔秀彬",
    nameEn: "Choi Subin",
    type: "新闻主播",
    region: "首尔",
    debutYear: 2014,
    program: "财经直播间",
    position: "财经新闻主播",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20professional%20Korean%20female%20financial%20news%20anchor%20in%20grey%20suit%2C%20soft%20neutral%20background%2C%20clean%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-07&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=modern%20financial%20news%20studio%20with%20market%20charts%20and%20Korean%20female%20anchor%2C%20cool%20realistic%20lighting%2C%20sleek%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-07-cover&orientation=landscape",
    bio: "财经领域的权威女主播，对市场走势的解读清晰易懂。常年主持财经论坛与行业峰会，深受商界观众信赖。",
    followers: "141万",
    birthday: "1988-08-21",
    tags: ["财经", "专业", "权威"],
    heat: 83,
    updated: "2026-10-11",
  },
  {
    id: "oh-seeun",
    name: "吴世恩",
    nameEn: "Oh Seeun",
    type: "娱乐主播",
    region: "光州",
    debutYear: 2021,
    program: "明星直击",
    position: "娱乐记者型主持",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20stylish%20Korean%20female%20entertainment%20reporter%20in%20denim%20jacket%2C%20soft%20neutral%20background%2C%20bright%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-08&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=red%20carpet%20entertainment%20event%20with%20Korean%20female%20reporter%20interviewing%20stars%2C%20warm%20spotlights%2C%20glamorous%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-08-cover&orientation=landscape",
    bio: "从光州走出的娱乐新锐，以犀利的八卦嗅觉和得体的采访风格立足。她的一线明星独家采访备受网友期待。",
    followers: "96万",
    birthday: "1998-12-05",
    tags: ["新锐", "采访", "独家"],
    heat: 79,
    updated: "2026-10-14",
  },
  {
    id: "kim-hana",
    name: "金荷娜",
    nameEn: "Kim Hana",
    type: "综艺主播",
    region: "首尔",
    debutYear: 2016,
    program: "深夜脱口秀",
    position: "脱口秀主持",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20witty%20Korean%20female%20talk%20show%20host%20in%20black%20dress%2C%20soft%20dark%20neutral%20background%2C%20moody%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-09&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=cozy%20late%20night%20talk%20show%20set%20with%20Korean%20female%20host%20and%20guest%20sofa%2C%20warm%20ambient%20lights%2C%20modern%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-09-cover&orientation=landscape",
    bio: "以机智幽默的话题掌控力著称的脱口秀女主播，节目常年在深夜档收视领先。她的金句频频登上热搜，是语言类节目的标杆。",
    followers: "203万",
    birthday: "1992-07-19",
    tags: ["脱口秀", "机智", "深夜档"],
    heat: 90,
    updated: "2026-10-13",
  },
  {
    id: "lee-seoyeon",
    name: "李瑞妍",
    nameEn: "Lee Seoyeon",
    type: "新闻主播",
    region: "蔚山",
    debutYear: 2019,
    program: "天气与生活",
    position: "生活资讯主播",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20friendly%20Korean%20female%20weather%20anchor%20in%20light%20blue%20shirt%2C%20soft%20neutral%20background%2C%20clean%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-10&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=bright%20weather%20forecast%20studio%20with%20Korean%20female%20anchor%20and%20screen%20map%2C%20soft%20daylight%2C%20clean%20modern%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-10-cover&orientation=landscape",
    bio: "亲切的生活资讯主播，负责天气预报与生活小贴士栏目。她把复杂的气象信息讲得通俗易懂，是观众心中的邻家姐姐。",
    followers: "118万",
    birthday: "1995-05-11",
    tags: ["亲切", "生活", "天气"],
    heat: 77,
    updated: "2026-10-12",
  },
  {
    id: "baek-jia",
    name: "白智雅",
    nameEn: "Baek Jia",
    type: "娱乐主播",
    region: "首尔",
    debutYear: 2018,
    program: "时尚星闻",
    position: "时尚娱乐主持",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20chic%20Korean%20female%20fashion%20show%20host%20in%20cream%20trench%20coat%2C%20soft%20neutral%20background%2C%20bright%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-11&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=elegant%20fashion%20week%20runway%20with%20Korean%20female%20host%20in%20front%20row%2C%20warm%20spotlights%2C%20luxury%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-11-cover&orientation=landscape",
    bio: "时尚娱乐跨界女主播，常年出现在各大时装周与品牌活动。她对潮流的敏锐判断让她的时尚栏目成为粉丝的穿搭指南。",
    followers: "176万",
    birthday: "1994-10-08",
    tags: ["时尚", "穿搭", "时装周"],
    heat: 86,
    updated: "2026-10-14",
  },
  {
    id: "yoon-chaeyoung",
    name: "尹彩英",
    nameEn: "Yoon Chaeyoung",
    type: "综艺主播",
    region: "水原",
    debutYear: 2022,
    program: "新人综艺大赏",
    position: "新人综艺主持",
    avatar: "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20fresh%20Korean%20female%20rookie%20host%20in%20lavender%20cardigan%2C%20soft%20neutral%20background%2C%20bright%20editorial%20lighting%2C%20fashion%20photography&width=600&height=800&seq=streamer-12&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=youthful%20Korean%20rookie%20variety%20show%20stage%20with%20female%20host%20smiling%2C%20warm%20colorful%20lights%2C%20playful%20set%2C%20editorial%20photography&width=1200&height=800&seq=streamer-12-cover&orientation=landscape",
    bio: "水原地方台走出的综艺新星，2022 年通过新人选拔出道。清新自然的风格与不怕出糗的综艺感，让她成为最受期待的新面孔。",
    followers: "58万",
    birthday: "2000-02-14",
    tags: ["新人", "清新", "潜力股"],
    heat: 72,
    updated: "2026-10-10",
  },
];